<template lang="pug">
span(v-if='isLoggedIn')
  a.navbar-brand( :href='"#/" + namespace + "/" + key',
                  :class='{ "active": key == $route.params.page }',
                  v-for='(tab, key) in tabs',
                ) {{ $t(key) }}
    .sub-menus(:class='{"none": !tab.subtabs}')
      .container-fluid
        ul.navbar-collapse
          li
            a( :href='"#/" + sectionNamespace(key, subTab, subKey) + "/" + key + "/" + section(key, subTab, subKey) + "/"',
               :class='{ "active": isActive(key, subTab, subKey) }',
               v-if='subKey != "label"',
               v-for='(subTab, subKey) in tab.subtabs',
             ) {{ subNavLabel(subKey) }}
            a(v-if='!tab.subtabs')
</template>

<script>

import Modules from '@/components/_modules'
import { allowedModules } from '@/core/legacy-auth'
import tabs from '@/core/site-map/map.json'

export default {
  name: 'site-map',

  computed: {
    isLoggedIn() {
      return global.config ? true : this.$store.state.isLoggedIn
    },

    // application namespace
    namespace() {
      return global.config.namespace || 'd'// this.$router.currentRoute.params.namespace
    },

    tabs() {
      const tabs = this.sitemap || (this.namespace !== 'd' ? this.namespace === '404' ? allowedModules() : allowedModules()/* Modules */ : allowedModules())
      return tabs
    }
  },

  data() {
    return {
      sitemap: global.config.namespace && global.config.sitemap && global.config.sitemap[global.config.namespace],

      section(tab, subTab, subKey) {
        const url = tabs[tab] ? tabs[tab].pack && tabs[tab].pack[subTab] || this.tabs[tab].subtabs && this.tabs[tab].subtabs[subKey] : ''

        if (this.tabs[tab].subtabs && global.config.namespace) {
          return subKey
        }
        return url
      },

      isActive(tab, subTab, subKey) {
        if (this.tabs[tab].subtabs && global.config.namespace) {
          return this.$route.params.section === subKey
        }
        const url = tabs[tab] ? tabs[tab].pack && tabs[tab].pack[subTab] || this.tabs[tab].subtabs && this.tabs[tab].subtabs[subKey] : ''
        return url === this.$route.params.section + (this.$route.params.action ? '/' + this.$route.params.action : '')
      },

      sectionNamespace(tab, subTab, subKey) {
        if (global.config.namespace) return global.config.namespace
        return Modules[tab] && !Modules[tab].entry && !Modules[tab].notImplemented || Modules[tab + '/' + this.section(tab, subTab, subKey)] ? 'd' : 'i'
      },

      subNavLabel(key) {
        return this.$t(key.replace(/-/g, ' '))
      }
    }
  }
}

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.navbar-primary a {
  text-transform: capitalize;
}
.theme.skin .navbar-primary .sub-menus.none {
  background-color: $canvas;
  padding-bottom: 0.6rem;
  border-top: 3px solid $background-light;
}

</style>



// WEBPACK FOOTER //
// index.vue?44cb53ed